import React from 'react';

const Inicio = () =>{
    return(    
        <>

        <div style={{paddingTop:55,backgroundColor:"aliceblue"}}>
            <div className='container' >
                <div className='MisionVision'>
                    <div className='grid-item'>
                        <div className='column'>
                            <h2 style={{borderLeft:"solid",borderWidth:10,borderColor:"#C4C4C4"}}><b>&nbsp; Mision</b></h2>
                            <p>Facilitar educación tecnológica de calidad certificada con el fin de capacitar jóvenes para incorporarlos al sector productivo a la educación superior.</p>
                        </div>
                    </div>
                    <div className='grid-item'>
                        <div className='column'>
                            <h2 style={{borderLeft:"solid",borderWidth:10,borderColor:"#C4C4C4"}}><b>&nbsp; Vision</b></h2>
                            <p>Ser en la región la mejor institución de educación media superior tecnológica certificada, orientada al aprendizaje, razonamiento y desarrollo de conocimientos humanísticos.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container' style={{marginTop:50}} >
                <div className='row'>
                    <div className='col-12 col-md-6'>
                        <iframe className='medidaVideo' src="https://player.vimeo.com/video/706169947?h=aa8ac6c2eb&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="100%" height="317" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Cetis158 &amp;iexcl;Estudia con nosotros!"></iframe>
                    </div>
                    <div className='col-12 col-md-6' style={{paddingLeft:25}}>
                        <span><b>Cetis 158 Villaflores, </b></span>
                        <span>Te invita a continuar tus estudios de bachillerato y a la vez concluir una carrera tecnica en:</span><br></br><br></br>
                        <span>
                            <ul>
                                <li>Mantenimiento Automotriz</li>
                                <li>Contabilidad</li>
                                <li>Laboratorio clinico</li>
                                <li>Enfermeria</li>
                                <li>Ciencia de datos e Informacion</li>
                            </ul>
                        </span><br></br>
                        <span><b>!Estudia con Cetis 158 es tu mejor opcion!</b></span><br></br>
                    </div>
                </div>
            </div>
            <br></br>
            <div className='container' style={{marginTop:50}} >
                <div className='row'>
                    <div className='col-12 col-md-6'>
                        <h5><b>¿Porque estudiar en esta institución?</b></h5><br/>
                        <ul>
                            <li>
                                <span>
                                    Al finalizar tus estudios obtendrás un certificado de bachillerato, una Cedula y Titulo Profesional.
                                </span>
                            </li>
                            <li>
                                <span>
                                    Becas
                                </span>
                            </li>
                            <li>
                                <span>
                                    Profesores altamente capacitados
                                </span>
                            </li>
                            <li>
                                <span>
                                    Areas verdes
                                </span>
                            </li>
                            <li>
                                <span>
                                    Canchas de Futbol y basquetbol
                                </span>
                            </li>
                        </ul>
                        
                    </div>
                    <div className='col-12 col-md-6' style={{paddingLeft:25}}>
                        
                    </div>
                </div>
            </div>
        </div>


        </>
    )

}
export default Inicio;